import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ParentContainor from '../../components/base/ParentContainor';
import { ROUTE_ENUM } from '../../routes/RoutesConstant';
import { logger } from '../../utils/logger';
import { TEXT_LABELS } from '../../constants/TextLabelConstants';
import { FONTS } from '../../constants/Fonts';
import GradientText from '../../components/base/GradientText';
import mqttService from '../../services/mqttService';
import Card from '../../components/base/Card';
import EmptyRoom from '../../components/EmptyRoom';
import ImageView from '../../components/base/ImageView';
import { IMAGE_CONSTANTS } from '../../constants/ImageConstans';

const RapFireJoinAnotherRoom = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { joinableRoom: initialJoinedRoom } = location.state || {};

  const [joinableRoom] = useState(initialJoinedRoom || null);
  const [displayRoomName] = useState(initialJoinedRoom?.roomName || '');
  const [displayRoomType] = useState(initialJoinedRoom?.roomType || '');
  const [joinedUsersList, setJoinedUsersList] = useState(initialJoinedRoom?.userArr || []);

  const hasNavigatedRef = React.useRef(false);

  useEffect(() => {
    const contestId =
      initialJoinedRoom?.contestId ||
      initialJoinedRoom?.gameId ||
      initialJoinedRoom?.roomId ||
      '';
    if (!contestId) {
      navigate(ROUTE_ENUM.SELECT_RAP_FIRE_GAME.routePath, {
        replace: true,
        state: { openJoinModal: true },
      });
      return undefined;
    }

    try {
      mqttService.connect('rapFire/room/', contestId, {
        'user-join': (payload) => {
          const joinedUsers = payload?.joinedUsers || [];
          setJoinedUsersList(joinedUsers);
        },
        start_game: (payload) => {
          if (!hasNavigatedRef.current) {
            hasNavigatedRef.current = true;
            mqttService.disconnect();
            const liveContestId = payload?.contestId || contestId;
            navigate(ROUTE_ENUM.RAP_FIRE_GAME.routePath, {
              replace: true,
              state: {
                contestId: liveContestId,
                nextGame: { contestId: liveContestId, gameId: liveContestId },
              },
            });
          }
        },
        error: (err) => {
          console.error('MQTT error:', err);
        },
        complete: () => {
          logger.log('MQTT subscription complete');
        },
      });
    } catch (error) {
      console.error('MQTT connection error:', error);
    }

    return () => {
      mqttService.disconnect();
    };
  }, [navigate, initialJoinedRoom]);

  if (!joinableRoom) {
    return null;
  }

  return (
    <ParentContainor
      route={ROUTE_ENUM.SELECT_RAP_FIRE_GAME}
      parentContainorStyle={{ justifyContent: 'center' }}
      isShowHeader={true}
      isBreadcrumbVisible={true}
      breadCrumbShowBack={true}
      breadCrumbOnBack={() => navigate(ROUTE_ENUM.SELECT_RAP_FIRE_GAME.routePath)}
      items={[]}
    >
      <div
        style={{
          display: 'flex',
          flex: 1,
          height: '78%',
          width: '100%',
          flexDirection: 'column',
          gap: 30,
          padding: 10,
          justifyContent: 'space-around',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            flex: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            justifyContent: 'flex-start',
          }}
        >
          <GradientText
            text={`Join ${displayRoomType ? displayRoomType : ''} Room`}
            fontWeight={700}
            fontSize={42}
            fontFamily={FONTS.MONTSERRAT_BOLD}
            style={{ marginTop: -100 }}
          />
        </div>

        <div
          style={{
            display: 'flex',
            flex: 1,
            height: '80%',
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'space-around',
            alignItems: 'center',
            gap: 30,
            marginTop: 0,
          }}
        >
          <Card
            elevation={5}
            radius={20}
            animation={true}
            style={{
              display: 'flex',
              padding: '20px',
              height: '100%',
              width: '60%',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                flex: 0.6,
                height: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginTop: '100px',
              }}
            >
              {displayRoomName ? (
                <GradientText
                  text={`Welcome to ${displayRoomName} Room`}
                  fontSize="45px"
                  fontWeight="600"
                  textColor="#FF6748"
                  style={{ width: '100%', textAlign: 'center', lineHeight: '1.2' }}
                />
              ) : (
                <div style={{ width: '100%', textAlign: 'center' }} />
              )}

              <ImageView
                src={IMAGE_CONSTANTS.PLEASE_HOLD_TIGHT}
                alt="Rapchik Logo"
                width="150px"
                height="150px"
                objectFit="contain"
              />

              <GradientText
                text="Please hold tight. Your host will start the game shortly!"
                fontSize="35px"
                fontWeight="400"
                style={{ width: 'auto', textAlign: 'center', lineHeight: '1.2' }}
              />
            </div>
          </Card>

          <Card
            elevation={5}
            radius={20}
            animation={true}
            style={{
              display: 'flex',
              paddingLeft: 20,
              paddingRight: 20,
              paddingTop: 20,
              paddingBottom: 0,
              height: '100%',
              width: '30%',
              justifyContent: 'start',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            {joinedUsersList?.length > 0 ? (
              <div
                style={{
                  display: 'flex',
                  flex: 1,
                  height: '100%',
                  width: '100%',
                  flexDirection: 'column',
                  gap: 0,
                  justifyContent: 'start',
                  alignItems: 'start',
                }}
              >
                <GradientText
                  text={`${TEXT_LABELS.RAP_FIRE_ROOM_GAME_CODE_SHARE_TOTAL_JOINED}${joinedUsersList?.length || 0}`}
                  fontWeight={700}
                  fontSize={24}
                  textColor="#FFFFFFE5"
                  style={{ marginTop: 0 }}
                />

                <div
                  style={{
                    flex: 1,
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'start',
                    overflowY: 'auto',
                    marginTop: 10,
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                  }}
                >
                  {joinedUsersList?.map((player, index) => {
                    const avatar = player?.avatar || IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER;
                    const username = player?.username || '';
                    return (
                      <div
                        key={player?.id || index}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'rotate(-0deg) scale(1.01)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'rotate(-0deg) scale(1)';
                        }}
                        style={{
                          flex: 0,
                          flexDirection: 'row',
                          height: 'auto',
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          transform: 'rotate(-0deg)',
                          transition: 'transform 0.3s ease',
                          marginBottom: 5,
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flex: 1,
                            height: '100%',
                            width: '100%',
                            flexDirection: 'row',
                            gap: 20,
                            justifyContent: 'start',
                            alignItems: 'center',
                          }}
                        >
                          <GradientText
                            text={index + 1}
                            fontWeight={500}
                            fontSize={16}
                            textColor="#FFFFFF"
                            style={{ marginTop: 0 }}
                            color="#5FE72EB2"
                          />

                          <ImageView
                            src={avatar}
                            alt={username}
                            width="40px"
                            height="40px"
                            borderRadius="50%"
                            objectFit="contain"
                            border="1px solid #FFFFFF33"
                          />

                          <GradientText
                            text={username}
                            fontWeight={600}
                            fontSize={18}
                            textColor="#FFFFFFB2"
                            style={{ marginTop: 0 }}
                          />
                        </div>

                        <GradientText
                          text="Joined"
                          fontWeight={600}
                          fontSize={14}
                          textColor="#5FE72EB2"
                          style={{ marginTop: 0 }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <EmptyRoom />
            )}
          </Card>
        </div>
      </div>
    </ParentContainor>
  );
};

export default RapFireJoinAnotherRoom;
